<template>
  <div>
    <h1>Vehicle Info</h1>
    <div
      v-if="account"
    >
      <form class="form-inline">
        <div class="form-group">
          <label for="previousVehicle" class="control-label">Copy from previous policy</label>
          <select v-model="selectedPreviousVehicle" id="previousVehicle" class="form-control">
          <!-- <option></option> -->
          <option
            v-for="previousVehicle in previousVehicles"
            v-bind:key="previousVehicle.policySpecification"
            v-bind:value="previousVehicle">
            {{ previousVehicle.policySpecification }} --{{ previousVehicle.year}} {{ previousVehicle.make }} {{ previousVehicle.model }}
          </option>
        </select>
        </div>
        <div class="form-group">
          <button v-on:click="usePreviousVehicle(selectedPreviousVehicle)" class="btn btn-default" type="button">Copy</button>
        </div>
      </form>
    </div>

    <vehicle-form />

  </div>
</template>

<script>
import {mapActions} from 'vuex'
import axios from "axios";
import VehicleForm from "./VehicleForm.vue";

export default {
  name: "VehiclePolicyPart",
  components: {
    VehicleForm,
  },
  props: [
    'account',
  ],
  data: function() {
    return {
      previousVehicles: [],
      selectedPreviousVehicle: null,
    };
  },
  computed: {
  },
  beforeMount: function() {
    if (this.account) {
      let account_id = this.account.id
      axios.get(`/staff-api/previous-vehicles/${account_id}`).then(response => {
        this.previousVehicles = response.data
      })
    }
  },
  methods: {
    ...mapActions([
      'usePreviousVehicle',
    ]),
  }
};
</script>

<style>
</style>
